import React, { ChangeEvent } from 'react';

import constants from 'constants/constants';
import { Control, FieldErrors, UseFormHandleSubmit, UseFormSetValue } from 'react-hook-form';

import useUserHook from 'hooks/useUserHook';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import {
    ADDITION_OPTIONS,
    IFields,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addAssociatedDocuments/addAssociatedDocuments';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addAssociatedDocuments/desktop/addAssociatedDocuments.desktop.module.scss';
import { formatNameForUplodaedFile } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addAssociatedDocuments/mobile/addAssociatedDocuments.mobile.utils';
import { AddLinkToFile } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addLinkToFile/AddLinkToFile';
import { Button } from 'components/DesignSystem/Button';
import { Modal } from 'components/DesignSystem/Modal';

interface Props {
    showAddAssociatedDocuments: boolean;
    handleCancel: () => void;
    handleSubmit: UseFormHandleSubmit<IFields, IFields>;
    handleSave: (data: any) => void;
    documentMode: ADDITION_OPTIONS | null;
    setDocumentMode: React.Dispatch<React.SetStateAction<ADDITION_OPTIONS | null>>;
    handleFileChosen: (file: File) => void;
    errors: FieldErrors<IFields>;
    control: Control<IFields, any, IFields>;
    setValue: UseFormSetValue<IFields>;
    hasExternalDocumentsProperty: boolean;
}

export const AddAssociatedDocumentsDesktop = ({
    showAddAssociatedDocuments,
    handleCancel,
    handleSubmit,
    handleSave,
    documentMode,
    setDocumentMode,
    handleFileChosen,
    errors,
    control,
    setValue,
    hasExternalDocumentsProperty,
}: Props) => {
    const { firstName, lastName } = useUserHook();
    const handleFileChosenDesktop = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const originalFile = e.target.files[0];
            const originalFileNameSplitted = originalFile.name.split('.');
            const originalFileExtension = originalFileNameSplitted[originalFileNameSplitted.length - 1];
            let formatedFileName = formatNameForUplodaedFile(firstName, lastName).concat(`.${originalFileExtension}`);
            const renamedFile = new File([originalFile], formatedFileName, {
                type: originalFile.type,
                lastModified: originalFile.lastModified,
            });
            handleFileChosen(renamedFile);
        }
    };

    return (
        <Modal
            width={constants.DEFAULT_MODAL_WIDTH}
            open={showAddAssociatedDocuments}
            onClose={handleCancel}
            title={'Attachments'}
        >
            <form
                data-testid={'add-associated-documents-container'}
                className={classes.addAssociatedDocumentsContainer}
                onSubmit={(e) => {
                    e.stopPropagation();
                    return handleSubmit(handleSave)(e);
                }}
            >
                {documentMode === null && (
                    <div className={classes.buttonsWrapper}>
                        <div className={classes.iconWithButton}>
                            <MuiIcon icon={'link'} fontSize={'30px'} />
                            <Button
                                variant={'tertiary'}
                                onClick={() => {
                                    setDocumentMode('addLink');
                                }}
                                size={'small'}
                            >
                                <span className={classes.actionName}>Add Link to File</span>
                            </Button>
                        </div>
                        {hasExternalDocumentsProperty && (
                            <div className={classes.iconWithButton}>
                                <MuiIcon icon={'article'} fontSize={'30px'} />
                                <Button
                                    variant={'tertiary'}
                                    size={'small'}
                                    component={'label'}
                                    id={'associated-document-upload-file-button'}
                                >
                                    <input
                                        type={'file'}
                                        id={'file'}
                                        hidden
                                        accept={
                                            '.jpg, .png, .jpeg, .gif, .txt, .pdf, .csv, .xls, .xlsx, .doc, .docx, .ppt, .pptx'
                                        }
                                        onChange={(e) => {
                                            handleFileChosenDesktop(e);
                                        }}
                                    />
                                    <span className={classes.actionName}>Upload File From Device</span>
                                </Button>
                            </div>
                        )}
                    </div>
                )}
                {documentMode === 'addLink' && (
                    <AddLinkToFile errors={errors} setValue={setValue} control={control} handleCancel={handleCancel} />
                )}
            </form>
        </Modal>
    );
};
